import { render, staticRenderFns } from "./VersionText.vue?vue&type=template&id=7acc5047&scoped=true"
import script from "./VersionText.vue?vue&type=script&lang=js"
export * from "./VersionText.vue?vue&type=script&lang=js"
import style0 from "./VersionText.vue?vue&type=style&index=0&id=7acc5047&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acc5047",
  null
  
)

export default component.exports